var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "additional-menu" },
        [
          _c("MenuItem", {
            class: { "router-link-active": _vm.showDialog },
            attrs: { item: _vm.item },
            nativeOn: {
              click: function($event) {
                return _vm.openDialog.apply(null, arguments)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDialog
        ? _c("contact-us", {
            staticClass: "contact-us__popup",
            attrs: { showDialog: _vm.showDialog },
            on: { "close-dialog": _vm.closeDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8a43962", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a43962","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/AdditionalMenu.vue
// module id = 7or7
// module chunks = 1